<div class="modal-header">
  <h3 class="m-0">Transfer of keepership completed</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
  </button>
</div>

<div class="modal-body">
  <p><strong>Congratulations on Your New Friend!</strong></p>
  <p>
    You’ve successfully completed the transfer of keepership. Your new furry friend is now
    officially part of your account!
  </p>
  <p class="mb-0">
    To make the most of your pet's journey, check out our memberships and products designed
    to keep them happy and healthy. Click the button below to explore what we offer.
  </p>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary text-white btn-lg"
    (click)="activeModal.dismiss()"
  >
    <img
      *appFeatureFlag="'isPawnVisibleInButton'"
      width="28"
      class="me-1"
      src="assets/images/identibase/whitepawlarge.png"
      alt="White paw"
    />
    Explore
  </button>
</div>
